<template>
  <h4>PageTemplate.vue</h4>

  
<p>This grid layout contains six columns and three rows:</p>

<div class="grid-container">
  <div class="item1">Header</div>
  <div class="item2">Menu</div>
  <div class="item3">Main</div>  
  <div class="item4">Right</div>
  <div class="item5">Footer</div>
</div>


</template>

<script>
export default {
  data() {return{};},
  props: {},
  emits: [],
  watch: {},
  beforeCreate() {
    console.log('**** beforeCreate ****');
  },
  created() {
    console.log('**** created ****');
  },
  beforeMount(){
    console.log('**** beforeMount ****');
  },
  mounted () {
    console.log('**** mounted ****');
  },
  beforeUpdate() {
    console.log('**** beforeUpdate ****');
  },
  updated() {
    console.log('**** updated ****');
  },
  beforeUnmount() {
    console.log('**** beforeUnmount ****');
  },
  unmounted() {
    console.log('**** unmounted ****');
  },
  components: {},
  computed: {},
  methods: {},
};
</script>

<style scoped>

/* ----------------- GRID ------------------------- */

.item1 { grid-area: header; }
.item2 { grid-area: menu; }
.item3 { grid-area: main; }
.item4 { grid-area: right; }
.item5 { grid-area: footer; }

.grid-container {
  display: grid;
  grid-template-areas:
    'header header header header header header'
    'menu main main main right right'
    'menu footer footer footer footer footer';
  gap: 10px;
  background-color: #2196F3;
  padding: 10px;
}

.grid-container > div {
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  padding: 20px 0;
  font-size: 30px;
}
</style>
